<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb></breadcrumb>
          <v-divider />
          <!-- main view -->
          <div>
            <v-row>
              <v-col cols="3" class="pa-0">
                <general-settings-tabs></general-settings-tabs>
              </v-col>
              <v-col cols="9">
                <v-row>
                  <v-col cols="6"></v-col>
                  <v-col cols="6" v-if="userType > 8">
                    <v-btn
                      @click="openNewReason"
                      depressed
                      class="gen-button white--text"
                      color="#60a45f"
                    >
                      <v-icon>add</v-icon>
                      <span>Add Reason</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <div class="divider">
                  <v-divider />
                </div>
                <v-row>
                  <v-col cols="12">
                    <p
                      class="text-center py-12"
                      v-if="cancellationReasons.length < 1"
                    >
                      No cancellation reason yet. Click <b>Add Reason</b> to get
                      started
                    </p>
                    <div class="table-menu" v-else>
                      <table class="tableUI staffTable">
                        <thead>
                          <tr>
                            <th>Reason</th>
                            <th v-if="userType > 8">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(reason, index) in cancellationReasons"
                            :key="index"
                          >
                            <td>{{ reason.content }}</td>
                            <td v-if="userType > 8">
                              <v-btn
                                depressed
                                class="delete-btn"
                                :ripple="false"
                                :loading="deleteLoader && index == loaderNum"
                                @click="
                                  deleteReason(reason.id);
                                  loaderNum = index;
                                "
                              >
                                <v-icon class="table-icon">delete</v-icon>
                                <span>Delete</span>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <div v-if="addNewReasonActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Cancellation Reason</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <div class="form-group">
                      <v-row>
                        <v-col cols="12">
                          <label for="">Add Reason:</label><br /><br />
                          <v-text-field
                            v-model="reason"
                            label=""
                            height="25"
                            :rules="[rules.required]"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-form>
                  <div class="dialogAction text-right">
                    <v-btn
                      @click="
                        openDialog = false;
                        addNewReasonActive = false;
                      "
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      class="success"
                      :loading="loader"
                      @click="addNewReason"
                    >
                      OK
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <!-- VIEW END -->
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import general_settings_tabs from "@/components/generalSettingsTab";
import main_Nav from "@/components/mainNav";
import { mapState } from "vuex";

import axios from "axios";
export default {
  data() {
    return {
      titleSub: "Surcharges",
      dataReady: false,
      loader: false,
      reasons: [],
      deleteLoader: false,
      loaderNum: -1,
      openDialog: false,
      addNewReasonActive: false,
      name: "",
      reason: "",
      surchargeType: "",
      rate: "",
      rules: {
        required: (value) => !!value || "Required",
      },
    };
  },
  methods: {
    deleteReason(id) {
      //   Start Loader
      this.deleteLoader = true;

      axios
        .delete("/api/v1/reason/cancel/" + id, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          // Refresh cancellation reasons
          this.$store.dispatch("getAllCancelationsReasons");

          //   Stop Loader
          this.deleteLoader = false;
        })
        .catch(() => {
          //   Stop Loader
          this.deleteLoader = false;
        });
    },
    openNewReason() {
      this.addNewReasonActive = true;
      this.openDialog = true;
    },
    addNewReason() {
      // Start Loader
      this.loader = true;

      axios
        .post(
          "/api/v1/reason/cancel",
          { content: this.reason },
          {
            headers: { Authorization: this.$store.state.token },
          }
        )
        .then(() => {
          this.addNewReasonActive = false;
          this.openDialog = false;

          this.loader = false;

          // Refresh cancellation reasons
          this.$store.dispatch("getAllCancelationsReasons");
          this.$refs.dialogForm.reset();
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
  watch: {
    openDialog(val) {
      if (val == false) {
        this.$refs.dialogForm.reset();
      }
    },
    cancellationReasons(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
  },
  created() {
    this.$store.dispatch("getAllCancelationsReasons");
  },
  computed: {
    ...mapState(["mainNav", "cancellationReasons", "userType"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
    "general-settings-tabs": general_settings_tabs,
  },
};
</script>

<style scoped>
.staffTable {
  width: 97%;
}

.filter-div-title {
  margin-left: 2%;
}

.filter-div-flex {
  margin-right: 26%;
  margin-left: 6%;
}

.gen-button {
  width: 30%;
  margin-right: 8%;
  float: right;
}

.table-menu {
  width: 96%;
  margin-left: 3%;
  margin-top: 2%;
}

.delete-btn {
  text-transform: capitalize;
  font-size: 13px;
  margin-top: 5%;
  margin-left: 10%;
  margin-bottom: 5%;
  border: 1px solid grey;
}

.table-icon {
  font-size: 13px;
}

.modal-form-btn {
  text-transform: capitalize;
  margin-left: 1%;
}
</style>
